import { Component, h, Prop, State, Event, EventEmitter, Listen, Host } from '@stencil/core';
import { addStyleSettings } from '../../utils/custom-style';
import { selection } from '../../store/selection.store';


@Component({
  tag: 'tambr-checkout-notes',
  styleUrl: 'tambr-checkout-notes.css',
  shadow: true,
})
export class TambrCheckoutNotes {

  @Prop() notes: string;

  @State() note: string = null;

  @Event() tambrCheckoutNotesDialogClose: EventEmitter;

  @Listen('click') onClickEvent( ev: MouseEvent ) {
    const targets = ev.composedPath() as EventTarget[];
    if (targets[0] instanceof Element && targets[0].id === 'tambr-notes-dialog') {
      return this.close();
    }
  }

  textareaMaxLength: number = 1000;

  componentWillLoad() { 
    this.note = selection.note; 
  }

  save( event: Event ) { 
    event.preventDefault();
    selection.note = this.note;
    this.close();
  }

  handleNotesChange( event: Event ){ 
    const target = event.target as HTMLTextAreaElement;
    this.note = target.value;
  }

  clear() { this.note = null; }

  close() { this.tambrCheckoutNotesDialogClose.emit(); }


  render() {
    return (
      <Host style={ addStyleSettings() }>
        <form id="tambr-notes-dialog" class="tambr-overlay" onSubmit={ (ev) => this.save(ev) } >
          <div class='tambr-modal-window notes-window'>

            <div class="tambr-modal-header">
              <tambr-icon type="close" class="close-button" onClick={ () => this.close() } />
            </div>

            <div class="tambr-modal-body with-padding">
              { this.renderNotes() }   
              
              <div class="tambr-action-buttons stacked">
                <button type="submit" class='tambr-button'><span>Save</span></button>
                <div class="tambr-clear-button" onClick={ () => this.close() }>Cancel</div>
              </div>
            </div>

          </div>
        </form>
      </Host>
    );
  }

  renderNotes(){
    return (
      <div class="tambr-form-item">
        <textarea id="notes" name="notes" maxlength={ this.textareaMaxLength } placeholder='Add your comments...' 
          value={ this.note } onInput={ (event) => this.handleNotesChange(event) }>
            { this.note }
        </textarea>

        <div class="notes-status">
          <span>{ this.note?.length }/{ this.textareaMaxLength }</span>
          <a class="tambr-clear-button clear-btn" onClick={ () => this.clear() }>Clear</a>
        </div>
      </div>
    );    
  }

}
